import { render, staticRenderFns } from "./userAmountList.vue?vue&type=template&id=2f0af493&scoped=true&"
import script from "./userAmountList.vue?vue&type=script&lang=js&"
export * from "./userAmountList.vue?vue&type=script&lang=js&"
import style0 from "./userAmountList.vue?vue&type=style&index=0&id=2f0af493&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0af493",
  null
  
)

export default component.exports